import React, { useEffect, useState } from "react";
import "./App.scss";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import { Login } from "./pages/login/Login";
import { RootState } from "./store/store";
import { useDispatch, useSelector } from "react-redux";
import { Clients } from "./pages/Clients/Clients";
import { setAxiosToken } from "./api";
import { DefaultLayout } from "./components/default_layout/DefaultLayout";
import { localStorageApi } from "./api/localStorage";
import { refreshUser } from "./store/user/userSlice";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { PricingLists } from "./pages/pricingLists/PricingLists";
import { getShop, resetShopState } from "./store/shop/shopSlice";
import { Orders } from "./pages/Orders/Orders";
import { Customers } from "./pages/Customers/Customers";
import { Promotions } from "./pages/Promotions";
import * as Sentry from "@sentry/react";
import { Drafts } from "./pages/Drafts";
import { Users } from "./pages/Users/Users";
import { TaxExemption } from "./pages/pricingLists/TaxExemption";
import { CompanyIssues } from "./pages/pricingLists/CompanyIssues";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: "https://858eefd958814146a503f8cfa0220c68@sentry.mydevops.org/7",
    environment: process.env.NODE_ENV,
    tracesSampleRate: 1.0,
  });
}

function App() {
  const user = useSelector((state: RootState) => state.user);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isLoggedIn = !!user?.id && !!user?.token;
    setIsAuthenticated(isLoggedIn);
    if (isLoggedIn) {
      Sentry.setUser({ email: user?.email });
    }
    setLoading(user?.loginLoading || false);

    if (isLoggedIn) {
      dispatch(getShop());
      dispatch(resetShopState());
    }
  }, [user, dispatch]);

  useEffect(() => {
    const token = localStorageApi.getToken();
    if (token) {
      setAxiosToken(token);
      dispatch(refreshUser(token));
    } else setLoading(false);
  }, [dispatch]);

  return (
    <div className="App">
      {loading ? (
        <div className="d-center" style={{ height: "100vh" }}>
          <Spin size="default" />
        </div>
      ) : (
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login isLoggedIn={isAuthenticated} />} />

            <Route
              path="/clients"
              element={
                <PrivateRoute isLoggedIn={isAuthenticated}>
                  <Clients />
                </PrivateRoute>
              }
            />
            {/* <Route
              path="/users"
              element={
                <PrivateRoute isLoggedIn={isAuthenticated}>
                  <Users />
                </PrivateRoute>
              }
            /> */}
            <Route
              path="/pricingLists/*"
              element={
                <PrivateRoute isLoggedIn={isAuthenticated}>
                  <PricingLists />
                </PrivateRoute>
              }
            />
            <Route
              path="/pricingLists/:id/tax_exemption"
              element={
                <PrivateRoute isLoggedIn={true}>
                  <TaxExemption />
                </PrivateRoute>
              }
            />
            <Route
              path="/pricingLists/:id/company_issues"
              element={
                <PrivateRoute isLoggedIn={true}>
                  <CompanyIssues />
                </PrivateRoute>
              }
            />

            <Route
              path="/orders/*"
              element={
                <PrivateRoute isLoggedIn={isAuthenticated}>
                  <Orders />
                </PrivateRoute>
              }
            />
            {/* <Route
              path="/drafts/*"
              element={
                <PrivateRoute isLoggedIn={isAuthenticated}>
                  <Drafts />
                </PrivateRoute>
              }
            /> */}
            <Route
              path="/customers/*"
              element={
                <PrivateRoute isLoggedIn={isAuthenticated}>
                  <Customers />
                </PrivateRoute>
              }
            />
            <Route
              path="/discounts/*"
              element={
                <PrivateRoute isLoggedIn={isAuthenticated}>
                  <Promotions />
                </PrivateRoute>
              }
            />

            <Route path="/" element={<Navigate to="/clients" />} />
          </Routes>
        </BrowserRouter>
      )}
    </div>
  );
}

const PrivateRoute = ({
  children,
  isLoggedIn,
}: {
  children: React.ReactNode;
  isLoggedIn: boolean;
}) => {
  return isLoggedIn ? <DefaultLayout>{children}</DefaultLayout> : <Navigate to="/login" />;
};

export default App;
